import Document from '../views/documents/Index.vue';
import { checkauth } from '../Helper';

// inserimento, modifica e dettaglio sono pagine: tornando indietro la lista riparte dal suo URL
const DocumentCreate = () => import('../views/documents/Create.vue');
const DocumentEdit = () => import('../views/documents/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/documents',
		name: 'documents',
		component: Document,
		beforeEnter: auth,
	},
	{
		path: '/documents/new',
		name: 'document-new',
		component: DocumentCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id del documento (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/documents/:id([0-9a-fA-F]{24})',
		name: 'document-edit',
		component: DocumentEdit,
		beforeEnter: auth,
	},
];
